import React from 'react';
import { NoValue } from '@/Components/Primitives';
const Time = ({ time, empty }) => {
    if (!time) {
        return empty ?? <NoValue />;
    }

    const [hours, minutes] = time.split(':');

    return `${hours}:${minutes}`;
}

export default Time;